import LogList from '../../modules/Logs/LogsList/LogsList';

export default function LogsScreen() {
    
    return (
        <>
            <LogList/>
        </>
    );
}